import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {SignatureValidation, SignatureValidationStatus} from '../model/ausschreibung';

const STATUS_LABEL: Record<SignatureValidationStatus, string> = {
  valid: 'Signaturprüfung: gültig',
  invalid: 'Signaturprüfung: ungültig',
  no_signature: 'Signaturprüfung: keine Signatur gefunden',
  error: 'Signaturprüfung: Fehler bei Validierung',
};

const CHECK_TYPE_LABEL: Record<string, string> = {
  CERTIFICATE: 'Zertifikat',
  INTEGRITY: 'Integrität',
  MANDATOR: 'QES-Akkreditierung',
  REVOCATION: 'Widerruf',
  TIMESTAMP: 'Zeitstempel',
};

// stzh-Message-Icons (checkmark-circle-filled / Kreis mit ! / info-help-filled), viewBox 2 2 20 20
const ICON_PATH = {
  valid: 'M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10m-.997-6 7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414z',
  invalid: 'M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10m-1-15v6h2v-6zm0 8v2h2v-2z',
  pending: 'M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10m-1-11v6h2v-6zm0-4v2h2V7z',
};

@Component({
  imports: [CommonModule],
  selector: 'app-signature-validation-icon',
  templateUrl: './signature-validation-icon.component.html',
  styleUrls: ['./signature-validation-icon.component.scss'],
  standalone: true,
})
export class SignatureValidationIconComponent {

  @Input() validation?: SignatureValidation;
  @Input() loading: boolean = false;

  readonly pendingIconPath = ICON_PATH.pending;

  get statusLabel(): string {
    return STATUS_LABEL[this.validation!.status];
  }

  get iconPath(): string {
    return this.validation!.status === 'valid' ? ICON_PATH.valid : ICON_PATH.invalid;
  }

  checkTypeLabel(type: string): string {
    return CHECK_TYPE_LABEL[type] ?? type;
  }

  checkStatusLabel(status: string): string {
    return status === 'valid' ? 'OK' : 'fehlgeschlagen';
  }
}
